import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="weather"
export default class extends Controller {
  static targets = ["forecast"]
  
  connect() {
    // Close forecast when clicking outside
    document.addEventListener('click', this.handleClickOutside.bind(this))
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside.bind(this))
  }

  toggle(event) {
    event.stopPropagation()
    if (this.hasForecastTarget) {
      this.forecastTarget.classList.toggle('hidden')
    }
  }

  handleClickOutside(event) {
    if (this.hasForecastTarget && !this.element.contains(event.target)) {
      this.forecastTarget.classList.add('hidden')
    }
  }
}
